(function () {
  const WIDGET_JS  = 'https://assets.calendly.com/assets/external/widget.js';
  const WIDGET_CSS = 'https://assets.calendly.com/assets/external/widget.css';

  let calendlyReady = false;
  let loading = false;

  const ensureCalendlyLoaded = () => new Promise((resolve, reject) => {
    if (calendlyReady) return resolve();

    if (!loading) {
      loading = true;

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = WIDGET_CSS;
      document.head.appendChild(link);

      const s = document.createElement('script');
      s.src = WIDGET_JS;
      s.async = true;
      s.onload = () => { calendlyReady = true; resolve(); };
      s.onerror = () => reject(new Error('Calendly widget failed to load'));
      document.head.appendChild(s);
    }

    const tick = () => calendlyReady ? resolve() : setTimeout(tick, 50);
    tick();
  });

  const openCalendly = (url) => {
    if (!url) return;
    if (window.Calendly && window.Calendly.initPopupWidget) {
      window.Calendly.initPopupWidget({ url });
    }
  };

  // DELEGATION: reagiert auf Klicks auf <a> ODER Wrapper mit data-calendly-popup
  const delegatedClick = (e) => {
    const trigger = e.target.closest('[data-calendly-popup="true"], a[data-calendly-popup="true"]');
    if (!trigger) return;

    // URL entweder direkt am Trigger oder am nächsten Wrapper
    const url = trigger.getAttribute('data-calendly-url')
      || trigger.closest('[data-calendly-popup="true"]')?.getAttribute('data-calendly-url');

    if (!url) return;
    e.preventDefault();

    ensureCalendlyLoaded()
      .then(() => openCalendly(url))
      .catch((err) => console.error('[Calendly]', err));
  };

  document.addEventListener('click', delegatedClick, true); // capture hilft gegen StopPropagation

  // Debug-Hook (optional)
  window.__leviosaCalendlyFront = true;
})();
